// owned by WP-SEC-UI · navigation from the session layer, which sits above the router (app/providers.tsx): a history entry in the
// router's own shape, then a popstate so the data router follows (the same technique as the sign-in callbacks in @ncp/api-client).
export function softNavigate(path: string): void {
  const prev = (window.history.state ?? {}) as { idx?: number };
  const state = { usr: null, key: Math.random().toString(36).slice(2, 10), idx: (prev.idx ?? 0) + 1 };
  window.history.pushState(state, "", path);
  window.dispatchEvent(new PopStateEvent("popstate", { state }));
}
